export interface InsufficientStockItem {
  product_id: string;
  title: string;
  requested_quantity: number;
  available_stock: number;
}

export function parseStockError(errorMessage: string): InsufficientStockItem[] | null {
  try {
    const parsed = JSON.parse(errorMessage);
    if (parsed.error_key === 'insufficient_stock' && Array.isArray(parsed.items)) {
      return parsed.items;
    }
  } catch {
    if (errorMessage.includes('finns bara') || errorMessage.includes('inga fler kvar')) {
      return null;
    }
  }
  return null;
}
